import { render, staticRenderFns } from "./FederationControlAction.vue?vue&type=template&id=a5d7eb4c&scoped=true&"
import script from "./FederationControlAction.vue?vue&type=script&lang=js&"
export * from "./FederationControlAction.vue?vue&type=script&lang=js&"
import style0 from "./FederationControlAction.vue?vue&type=style&index=0&id=a5d7eb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d7eb4c",
  null
  
)

export default component.exports